module.exports={render:function (){with(this) {
  return _h('nav', {
    staticClass: "tool-bar navbar navbar-inverse navbar-fixed-top",
    attrs: {
      "style": "margin-bottom: 0"
    }
  }, [_h('div', {
    staticClass: "container-fluid",
    attrs: {
      "style": "padding-right: 15px"
    }
  }, [_m(0), " ", _h('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (ui.mode == 'edit'),
      expression: "ui.mode == 'edit'"
    }],
    staticClass: "nav navbar-nav navbar-right",
    attrs: {
      "id": "editing-btn-group",
      "data-bind": "with: controls"
    }
  }, [_h('li', [_h('button', {
    staticClass: "btn navbar-btn-o",
    class: {
      unsaved: editorNeedSave
    },
    attrs: {
      "id": "btn-save"
    },
    on: {
      "click": save
    }
  }, [_m(1), " Save\n        "])]), " ", _h('li', [_h('button', {
    staticClass: "btn navbar-btn",
    attrs: {
      "id": "btn-tidy"
    },
    on: {
      "click": tidy
    }
  }, [_m(2), " Tidy\n        "])]), " ", _m(3), " ", _h('li', [_h('button', {
    staticClass: "btn navbar-btn",
    attrs: {
      "id": "btn-compile"
    },
    on: {
      "click": compile
    }
  }, [_m(4), " Compile\n        "])])]), " ", _h('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (ui.mode == 'compile'),
      expression: "ui.mode == 'compile'"
    }],
    staticClass: "nav navbar-nav navbar-right",
    attrs: {
      "id": "compiling-btn-group",
      "style": "margin-right: -15px",
      "data-bind": "with: controls"
    }
  }, [_h('li', [_h('button', {
    staticClass: "btn navbar-btn-o",
    attrs: {
      "id": "btn-stop"
    },
    on: {
      "click": stop
    }
  }, [_m(5), " Stop\n        "])]), " ", _h('li', [_h('button', {
    staticClass: "btn navbar-btn",
    attrs: {
      "id": "btn-next"
    },
    on: {
      "click": next
    }
  }, [_m(6), " Next\n        "])]), " ", _h('li', [_h('button', {
    staticClass: "btn navbar-btn",
    attrs: {
      "id": "btn-ff"
    },
    on: {
      "click": ff
    }
  }, [_m(7), " Fast Forward\n        "])])])])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "navbar-header"
  }, [_h('div', {
    staticClass: "navbar-brand"
  }, [_h('span', {
    staticClass: "glyphicon glyphicon-console"
  }), "\n        Compiler\n      "])])
}},function (){with(this) {
  return _h('span', {
    staticClass: "glyphicon glyphicon-floppy-disk"
  })
}},function (){with(this) {
  return _h('span', {
    staticClass: "glyphicon glyphicon-flash"
  })
}},function (){with(this) {
  return _h('li', [_h('button', {
    staticClass: "btn navbar-btn",
    attrs: {
      "id": "btn-import",
      "data-bind": "click: importFile"
    }
  }, [_h('span', {
    staticClass: "glyphicon glyphicon-import"
  }), " Import\n        "])])
}},function (){with(this) {
  return _h('span', {
    staticClass: "glyphicon glyphicon-download-alt"
  })
}},function (){with(this) {
  return _h('span', {
    staticClass: "glyphicon glyphicon-stop"
  })
}},function (){with(this) {
  return _h('span', {
    staticClass: "glyphicon glyphicon-share-alt"
  })
}},function (){with(this) {
  return _h('span', {
    staticClass: "glyphicon glyphicon-fast-forward"
  })
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-b1047556!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToolBar.vue
 ** module id = 134
 ** module chunks = 2
 **/